import { render } from "./RightBar.vue?vue&type=template&id=16220abc&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"

import "./RightBar.vue?vue&type=style&index=0&id=16220abc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16220abc"]])

export default __exports__